export default "__VITE_ASSET__C9J8Esha__"